import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  white?: boolean;
  padding?: boolean;
}

export const LoadingSpinner = ({ 
  size = 'medium', 
  white = false, 
  padding = false 
}: LoadingSpinnerProps) => {
  return (
    <div className={`loading-spinner loading-spinner--${size} ${white ? 'loading-spinner--white' : ''} ${padding ? 'loading-spinner--padding' : ''}`}>
      <div className="loading-spinner__spinner"></div>
    </div>
  );
};

